import { CircleLayer } from "mapbox-gl";

const StationFillLayer: CircleLayer = {
  id: "station-fill-layer",
  type: "circle",
  paint: {
    "circle-radius": [
      "interpolate", ["linear"], ["zoom"],
      0, 2,
      6, 2,
      10, 8
    ],
    "circle-color": "white"
  }
}

export { StationFillLayer }
